var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9173 4.62565V5.12565H14.4173H18.334C18.7208 5.12565 19.0917 5.2793 19.3652 5.55279L19.7187 5.19923L19.3652 5.55279C19.6387 5.82628 19.7923 6.19721 19.7923 6.58398V17.3548C19.7923 17.7416 19.6387 18.1125 19.3652 18.386C19.0917 18.6595 18.7208 18.8132 18.334 18.8132H2.66732C2.28054 18.8132 1.90961 18.6595 1.63612 18.386L1.28257 18.7396L1.63612 18.386C1.36263 18.1125 1.20898 17.7416 1.20898 17.3548V6.58398C1.20898 5.77325 1.85659 5.12565 2.66732 5.12565H6.58398H7.08398V4.62565V2.66732C7.08398 1.85659 7.73159 1.20898 8.54232 1.20898H12.459C12.8458 1.20898 13.2167 1.36263 13.4902 1.63612L13.8419 1.2844L13.4902 1.63612C13.7637 1.90961 13.9173 2.28054 13.9173 2.66732V4.62565ZM12.459 5.12565H12.959V4.62565V2.66732V2.16732H12.459H8.54232H8.04232V2.66732V4.62565V5.12565H8.54232H12.459Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.f2ab5338.svg";
export { ForwardRef as ReactComponent };